import Vue from 'vue';
import VueRouter from 'vue-router';
import LayoutOverview from '../layouts/layout-overview.vue';
import { store } from '../store';
import groupIsValid from './navigation-guards/groupIsValid';

Vue.use(VueRouter);
const routes = [
  {
    path: '',
    redirect: {
      name: store.state.selectedGroup ? 'member-list' : 'group-list',
      params: { groupName: store.state.selectedGroup ? store.state.selectedGroup : undefined },
    },
  },
  {
    path: '/groups',
    component: () => import('@/layouts/layout-plain.vue'),
    children: [
      {
        path: '',
        name: 'group-list',
        component: () => import('@/views/group/group-list.vue'),
      },
    ],
  },
  {
    path: '/history',
    name: 'user-show-history',
    component: () => import('@/views/user/user-show-history.vue'),
  },
  {
    path: '/:groupName',
    component: LayoutOverview,
    beforeEnter(to, from, next) {
      if (!to.params.groupName) next({ name: 'group-list' });
      else next();
    },
    children: [
      {
        path: '',
        name: 'member-list',
        component: () => import('@/views/member/member-list.vue'),
      },
      {
        path: 'new-member',
        name: 'member-add',
        component: () => import('@/views/member/member-add.vue'),
      },
      {
        path: 'notifications',
        name: 'group-notifications',
        component: () => import('@/views/group/group-notifications.vue'),
      },
      {
        path: 'notifications/new',
        name: 'group-notifications-new',
        component: () => import('@/views/group/group-notifications-edit.vue'),
      },
      {
        path: 'notifications/:id',
        name: 'group-notifications-edit',
        component: () => import('@/views/group/group-notifications-edit.vue'),
      },
    ],
  },
  {
    path: '/:groupName/member/:userId',
    component: () => import('@/layouts/layout-member.vue'),
    beforeEnter(to, from, next) {
      if (!to.params.groupName) next({ name: 'group-list' });
      else next();
    },
    children: [
      {
        path: '',
        name: 'member-show',
        component: () => import('@/views/member/member-show.vue'),
      },
      {
        path: 'edit',
        name: 'member-edit',
        component: () => import('@/views/member/member-show-edit.vue'),
      },
      {
        path: 'add-task',
        name: 'member-show-add-task',
        component: () => import('@/views/member/member-show-add-task.vue'),
      },
      {
        path: 'edit-task/:taskId',
        name: 'member-show-edit-task',
        component: () => import('@/views/member/member-show-add-task.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// check if groupName is a valid group for the user
router.beforeEach((to, from, next) => {
  // routesWithoutGroup is a quick workaround for routes,
  // that do not required you to be in group scope
  const routesWithoutGroup = ['user-show-history'];
  if (to.params.groupName || routesWithoutGroup.includes(to.name)) {
    if (groupIsValid(to.params.groupName)) {
      store.commit('setGroup', to.params.groupName);
    } else {
      next({ name: 'group-list' });
    }
  }

  next();
});

export default router;
